
export default function Listings() {
  return null;
}
